import { useState } from 'react';
import toast from 'react-hot-toast';

function BarraBuscaCpf({ cpf, onChange }) {

    console.log('### Iniciando BarraBuscaCpf ###');

    let timer;

    function sobeCpf(cpf) {

        clearTimeout(timer);

        if (!cpf) return // No render iniciar ou caso o usuário limpe o campo

        const cpfNumerosOnly = cpf.replace(/\D/g, "");

        if (cpfNumerosOnly.length === 11) { // Não precisa aguarda, já tenho o cpf completo e jogo o dado 'pra cima'
            onChange(cpfNumerosOnly)
        }
        else {
            timer = setTimeout(() => {

                if (cpfNumerosOnly.length !== 11) {
                    toast.error("O CPF deve conter 11 dígitos");
                    return;
                }

            }, 3000);
        }
    }

    return (
        <div className="col-12 col-sm-6">
            <div className="">
                {/* <label for="cpf" class="form-label">CPF</label> */}
                <input
                    type="search"
                    className="form-control"
                    id="cpf"
                    placeholder="Buscar usuário pelo CPF"
                    onChange={(e) => sobeCpf(e.target.value)}
                />
            </div>
        </div>
    )
}

export default BarraBuscaCpf